import { useTranslation } from 'react-i18next';
import { cn } from '@noor/lib/cn';
import type { DeliveryStatus } from '../model/schema';
import {
  deliveryStatusTone,
  deliveryStatusLabelKey,
  type DeliveryTone,
} from '../lib/status';

/** Solid badge fill + foreground per tone. `neutral` matches the Figma gray/500. */
const TONE_CLASS: Record<DeliveryTone, string> = {
  sky: 'bg-delivery-sky text-delivery-badge-fg',
  orange: 'bg-primary text-primary-foreground',
  neutral: 'bg-status-neutral text-delivery-badge-fg',
  violet: 'bg-delivery-violet text-delivery-badge-fg',
  pink: 'bg-delivery-pink text-delivery-badge-fg',
  green: 'bg-delivery-green text-delivery-badge-fg',
  red: 'bg-delivery-red text-delivery-badge-fg',
};

interface DeliveryStatusBadgeProps {
  status: DeliveryStatus;
  className?: string;
}

/**
 * The Доставка status pill (Figma node 236:7527): a solid, tone-colored badge
 * with 10px bold white text and a faint ambient shadow. The entity owns the
 * status→tone decision; colors resolve through design tokens.
 */
export function DeliveryStatusBadge({ status, className }: DeliveryStatusBadgeProps) {
  const { t } = useTranslation('delivery');
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-xl px-2 py-1 text-[10px] leading-[11px] font-bold tracking-[-0.2px] whitespace-nowrap shadow-badge-halo',
        TONE_CLASS[deliveryStatusTone(status)],
        className,
      )}
    >
      {t(deliveryStatusLabelKey(status))}
    </span>
  );
}
